import callApi from "./callApi";
import callStoryAktif from "./callStoryAktif";
import callDetailStatus from "./callDetailStatus";
import callRiwayatStory from "./callRiwayatStory";

const actions = {
    ...callApi,
    ...callStoryAktif,
    ...callDetailStatus,
    ...callRiwayatStory,
    setFetching: ({ commit }, payload) => {
        commit("setFetching", payload);
    },
    setLoadMore: ({ commit }, payload) => {
        commit("setLoadMore", payload);
    },
    setFilter: ({ commit }, payload) => {
        commit("setFilter", payload);
    },
    setResponse: ({ commit }, payload) => {
        commit("setResponse", payload);
    },
    setListPerangkat: ({ commit }, payload) => {
        commit("setListPerangkat", payload);
    },
    resetDataDeviceTiny: ({ commit }) => {
        commit("setDataDeviceTiny", {});
    },
    setFileUpload: ({ commit }, payload) => {
        commit("setFileUpload", payload);
    },
    setDeviceid: ({ commit }, payload) => {
        commit("setDeviceid", payload);
    },
    resetPage: ({ commit }, payload) => {
        commit("resetPage", payload);
    },
    resetList: ({ commit }, payload) => {
        commit("resetList", payload);
    },
    setPreview: ({ commit }, payload) => {
        commit("setPreview", payload);
    },
};

export default actions;
